import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
}

const FacebookIcon: FunctionComponent<Props> = ({
  className = "",
  fill = "",
  width = 40,
  height = 40,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Facebook</title>
      <path
        d="M27.0174 21.7497L27.8495 16.3604H22.6403V12.8637C22.6403 11.3906 23.3668 9.95151 25.7019 9.95151H28.0714V5.36435C28.0714 5.36435 25.9212 5 23.866 5C19.5761 5 16.7707 7.57929 16.7707 12.2529V16.3604H12V21.7497H16.7707V34.7746C17.727 34.924 18.707 35 19.7055 35C20.704 35 21.6841 34.9214 22.6403 34.7746V21.7497H27.0174Z"
        fill={fill}
      />
    </svg>
  );
};

export default FacebookIcon;
